import { useEffect } from 'react';

function HomePageRedirect() {

  useEffect(function redirectToHomePage() {

    window.location.replace('/');

  }, []);

  return null;

}

export default HomePageRedirect;
